class MegamenuItem extends HTMLElement {
    constructor() {
      super();
      this.initMegaMenu();
    }
  
    initMegaMenu() {
      // Getting the parent under which we need to show the menu
      this.parentMenuHandle = this.dataset['dropdown'];
      this.parentMenu = document.querySelector(`.mega-menu__content[data-submenu="${this?.parentMenuHandle}"]`);
      // this.parentMenuMobile = document.querySelector(`.mega-menu__content-mobile[data-submenu="${this?.parentMenuHandle}"]`);
  
      if(this.parentMenuHandle && this.parentMenu) {
        this.parentMenu.querySelector('ul.mega-menu__list')?.remove();
        this.parentMenu.innerHTML = this.innerHTML;
      }

      // if(this.parentMenuHandle && this.parentMenuMobile) {
      //   this.parentMenu.querySelector('ul.mega-menu__list')?.remove();

      //   // Add menu into the the header so it can work on hover with CSS
      //   // TODO: Add Accessability for the menu on hover or focus.
      //   this.parentMenuMobile.innerHTML = this.innerHTML;
      // }
    }
  
  }
  
  customElements.define('megamenu-item', MegamenuItem);